export default __webpack_public_path__ + "static/goodfirms-ad2e1f20b66b83250526eb71abe6361a.webp";